"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=promotion.dto.js.map